export const SOFTLINE_FEATURE_FIBU_KUNDENINFO_LEISTE = 'fibuKundeninfoLeiste';
